import Header from "../../../../shared/components/Header";
import Footer from "../../../../shared/components/Footer";
import Steps from "../../components/Steps";
import {range} from "../../../../shared/utils";
import {CalculatorAPI} from "../../../../apis/CalculatorAPI";
import {mapGetters, mapState} from "vuex";
import store from "@/store";
import {Form, FormValidation} from "../../../../shared/directives/formValidation";
import {LookupsAPI} from "../../../../apis/LookupsAPI";
import FundUseInput from "../../components/FundUseInput";
import LeftInfoCol from "../../components/LeftInfoCol";
import FileBtn from "../../../../shared/components/file-btn"
import SummaryForm from "@/modules/calculator/forms/SummaryForm"
import TeamForm from "@/modules/calculator/forms/TeamForm";
import MarketProductForm from "@/modules/calculator/forms/MarketProductForm";
import BusinessModelForm from "@/modules/calculator/forms/BusinessModelForm";
import IPLegalForm from "@/modules/calculator/forms/IPLegalForm";
import {config} from "@/config/config";
import {ProfileAPI} from "@/apis/ProfileAPI";

const STEPS = {
  SUMMARY: 0,
  TEAM: 1,
  MARKET_PRODUCT: 2,
  BUSINESS_MODEL: 3,
  IP_LEGAL: 4,
};

export default {
  name: 'calculator',
  store,
  components: {
    Header,
    Footer,
    Steps,
    LeftInfoCol,
    FundUseInput,
    FileBtn,
    SummaryForm,
    TeamForm,
    MarketProductForm,
    BusinessModelForm,
    IPLegalForm,
  },
  data() {
    return {
      activeStep: 0,
      STEPS,
      loaded: false,
      loading: false,
      showResults: false,
      requestedFund: {},
      questionsGroup: {},
      hiddenQuestions:{
        'Q3': true,
        'Q5': true,
        'Q30': true,
        'Q49': true,
        'USE_OF_FUND_NO_FUND': true,
        'USE_OF_FUND_HAS_FUND': true,
        'INCORPORATION_LOCATION': true,
      },

      formData: {
        summary: {
        },
        team: {
          foundersDetails: []
        },
        marketProduct: { },
        businessModel: { },
        ipLegal: { },
      },

      file: {},
      answers: {},
      results: {},

      businessTypes: [],
      cities: [],
      states: [],

      companyProfileData: {},
      completedSteps: {},

    }
  },
  methods: {
    nextStep() {

      if(this.activeStep === STEPS.SUMMARY && this.$refs.summaryForm.isValid()){
        this.activeStep = STEPS.TEAM;
         $(window).scrollTop(0);
      }
      else if(this.activeStep === STEPS.TEAM && this.$refs.teamForm.isValid()){
        this.activeStep = STEPS.MARKET_PRODUCT;
         $(window).scrollTop(0);
      }
      else if(this.activeStep === STEPS.MARKET_PRODUCT && this.$refs.marketProductForm.isValid()){
        this.activeStep = STEPS.BUSINESS_MODEL;
         $(window).scrollTop(0);
      }
      else if(this.activeStep === STEPS.BUSINESS_MODEL && this.$refs.businessModelForm.isValid()){
        this.activeStep = STEPS.IP_LEGAL;
         $(window).scrollTop(0);
      }

    },
    goTo(step) {
      if (this.completedSteps[step]) {
        this.activeStep = step;
      }
    },
    prevStep() {
      if (this.activeStep > 0) {
        this.activeStep -= 1;
      }
    },
    isLastStep() {
      return this.activeStep === 4
    },
    isFirstStep() {
      return this.activeStep === 0
    },
    async submit() {

      if(!this.$refs.ipLegalForm.isValid()){
        return;
      }

      let data = {
        summary: this.$refs.summaryForm.getData(),
        marketProduct: this.$refs.marketProductForm.getData(),
        businessModel: this.$refs.businessModelForm.getData(),
        team: this.$refs.teamForm.getData(),
        ipLegal: this.$refs.ipLegalForm.getData(),
      };

      // clear hidden answers
      /*
      for( let group in this.questionsGroup) {
        for( let question of this.questionsGroup[group]) {
          if( this.hiddenQuestions[question.tag] === true && this.answers[question.id] === true) {
            delete this.answers[question.id];
          }
        }
      }

      if (!this.hiddenQuestions['INCORPORATION_LOCATION'] && this.companyProfileData.country && this.companyProfileData.country.id) {
        let isState = this.companyProfileData.state && this.companyProfileData.state.id;
        data.profile_data = {
          ...data.profile_data,
          incorporation_country_id: this.companyProfileData.country.id,
        }

        if( isState ) {
          data.profile_data['incorporation_state_id'] = this.companyProfileData.state.id;
        }

        if( this.companyProfileData.city && this.companyProfileData.city.id ) {
          data.profile_data['incorporation_city_id'] = this.companyProfileData.city.id;
        }
        // @TODO check if this extra peace of data required
        // delete data.profile_data.country;
      }*/
      this.loading = true;
      let resp = await CalculatorAPI.submitAnswers(data);
      setTimeout(()=>{
         this.loading = false;
      }, 100)
      if (resp.httpStatus === 200) {
        SFAnalytics.track('Valuation Created');
        this.$router.push({name: 'report', params: {'id': resp.report_id}});
      }
      else {
        this.$buefy.dialog.alert('Opps..! Something wrong happened please try again later.')
      }
    },
    async onFileUploaded(data, response) {
      console.log(data, response)
    },


  },
  async mounted() {
    $(window).scroll(() => {
      let currentScroll = $(window).scrollTop();
      if (currentScroll > this.scrollTop) {
        this.scrollTop = currentScroll;
      }
    });
    // let user = await LoginAPI.login('ahshukr@gmail.com', '123123');
    this.questionsGroup = await CalculatorAPI.getQuestions();
    this.loaded = true;
   if(this.isStartup){
      let profile = await ProfileAPI.getStartupProfile();

      this.formData.summary['industry_id'] =  profile.industry;
      this.formData.summary['country_id'] =  profile.country;

      // set question as selected tag
      let startupStageAnswerTag = "A"+(parseInt(profile.stage)+1);
      for(let question of this.questionsGroup['SUMMARY']){
        for( let answer of question.answer_set){
          if(question.tag === 'Q9' && answer.tag === startupStageAnswerTag){
            this.formData.summary['Q9'] =  answer;
            break;
          }
        }
        if( this.formData.summary['Q9']){
          break;
        }
      }
      // map startup stage to 0 -> A1, 1 ->A2 ..etc
      // this.formData.summary['Q9'] =  "A"+(parseInt(profile.stage)+1);

    }
    SFAnalytics.track('Valuation Started')

  },
  computed: {
    ...mapState(['groups']),
    ...mapGetters(['isStartup']),
  },
  props: {}
}
